import React from 'react';
import { Link } from 'react-router-dom';
import logo_dark from '../../assets/images/logo-light.png';
import logo_light from '../../assets/images/logo-light.png';
import { FaGithub, FaLinkedin, FaMediumM, FaRegEnvelope } from 'react-icons/fa';

export default function VegaFooter() {
  return (
    <footer
      style={{ borderTop: '1px solid var(--line-soft)', padding: '1.5rem 1.5rem 3rem' }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1.5rem',
        }}
      >
        {/* Logo + tagline */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src={logo_dark} alt="Vega" height="22" className="inline-block dark:hidden" style={{ height: '22px', width: 'auto' }} />
            <img src={logo_light} alt="Vega" height="22" className="hidden dark:inline-block" style={{ height: '22px', width: 'auto' }} />
          </Link>
          <span className="vd-ink-faint" style={{ fontSize: '0.75rem', marginLeft: '0.25rem' }}>
            Adopt *aaS faster · cheaper · smarter
          </span>
        </div>

        {/* Nav links */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '1.25rem',
            fontSize: '0.875rem',
          }}
        >
          <Link to="/privacy-policy" className="vd-ink-soft" style={{ textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            Privacy
          </Link>
          <Link to="/cookie-policy" className="vd-ink-soft" style={{ textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            Cookies
          </Link>

          <a href="https://github.com/ArchetypicalSoftware" target="_blank" rel="noreferrer"
            className="vd-ink-soft" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            <FaGithub /> GitHub
          </a>
          <a href="https://medium.com/archetypical-software" target="_blank" rel="noreferrer"
            className="vd-ink-soft" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            <FaMediumM /> Writing
          </a>
          <a href="https://www.linkedin.com/company/archetypical-software" target="_blank" rel="noreferrer"
            className="vd-ink-soft" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            <FaLinkedin /> LinkedIn
          </a>
          <a href="mailto:development@archetypical.software"
            className="vd-ink-soft" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', textDecoration: 'none', transition: 'color 0.15s' }}
            onMouseOver={e => e.currentTarget.style.color = 'var(--ink)'}
            onMouseOut={e => e.currentTarget.style.color = ''}>
            <FaRegEnvelope /> Email
          </a>
        </div>

        {/* Copyright */}
        <div
          className="vd-ink-faint"
          style={{ fontSize: '0.75rem', width: '100%', textAlign: 'right' }}
        >
          © {new Date().getFullYear()} Archetypical Software
        </div>
      </div>
    </footer>
  );
}
